import React from 'react';
import PropTypes from 'prop-types';

class MeasurementsStraight extends React.Component {
  componentDidMount() {
    this.validate();
  }

  componentWillUnmount() {
    if (this.props.errors.lengths) {
      this.props.setError('lengths');
    }
  }

  validate() {
    const { quantity, lengths = [] } = this.props.values;
    const newQuantity = quantity || 1;

    if (quantity !== newQuantity) {
      this.props.setValue('quantity', newQuantity);
    }

    if (newQuantity === lengths.length && newQuantity === lengths.filter(Boolean).length) {
      if (this.props.errors.lengths) {
        this.props.setError('lengths');
      }
    } else {
      if (!this.props.errors.lengths) {
        this.props.setError('lengths', 'required')
      }
    }
  }

  handleQuantityChange = (e) => {
    const { quantity: currQuantity, lengths = [] } = this.props.values;
    const quantity = parseInt(e.target.value, 10);

    const diff = quantity - currQuantity;

    if (diff < 0) {
      lengths.splice(diff);
    } else {
      for (let i = currQuantity; i < currQuantity + diff; i += 1) {
        lengths.push(0);
      }
    }

    this.props.setValue('lengths', lengths);
    this.props.setValue('quantity', quantity);
    this.updateTotalLength(lengths);

    setTimeout(() => this.validate(), 50);
  };

  handleLengthChange = (e, index) => {
    const { lengths = [] } = this.props.values;

    lengths[index] = parseInt(e.target.value, 10) || 0;

    this.props.setValue('lengths', lengths);
    this.updateTotalLength(lengths);

    setTimeout(() => this.validate(), 50);
  };

  updateTotalLength(lengths) {
    this.props.setValue('total_length', lengths.reduce((a, b) => a + b, 0));
  }

  render() {
    const { instructions = {} } = window.MTMReact;
    const { lengths = [], quantity } = this.props.values;
    const quantityOptions = [];
    const lengthInputs = [];

    for (let i = 1; i <= 8; i += 1) {
      quantityOptions.push(<option value={i} key={i}>{i}</option>);
    }

    for (let i = 0; i < quantity; i += 1) {
      const name = `lengths[${i}]`;

      lengthInputs.push((
        <label key={name} >
          Längd {i + 1} (mm)
          <input type="number" min="1" name="lengths" value={lengths[i] || ''} onChange={(e) => this.handleLengthChange(e, i)} />
        </label>
      ));
    }

    return (
      <React.Fragment>
        <h3 className="mtm-step-title-sub">Mått rak ledstång</h3>

        <div className="mtm-instructions" dangerouslySetInnerHTML={{ __html: instructions && instructions.straight }} />

        <label>
          Antal ledstänger
          <select name="quantity" onChange={this.handleQuantityChange} value={quantity}>
            {quantityOptions}
          </select>
        </label>

        {lengthInputs}
      </React.Fragment>
    );
  }
}

MeasurementsStraight.propTypes = {
  values: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
};

export default MeasurementsStraight;





// WEBPACK FOOTER //
// ./src/Step/steps/MeasurementsStraight.js